import { createReducer } from 'typesafe-actions';

import { DelegatorResult } from '@block-explorer/entities';

import { PaginatedReducerState } from '../utils';
import { getActiveAccountDelegationsAsync } from './actions';

type State = PaginatedReducerState<DelegatorResult>;

const initialState: State = {
  loading: false,
  error: null,
  byHash: {
    loading: false,
    error: null,
    items: {},
  },
  paginatedItems: [],
  totalItemCount: 0,
  totalPageCount: 0,
};

export default createReducer(initialState)
  .handleAction(
    getActiveAccountDelegationsAsync.request,
    (state, action): State => ({
      ...state,
      loading: true,
      error: null,
    })
  )
  .handleAction(
    getActiveAccountDelegationsAsync.failure,
    (state, action): State => ({
      ...state,
      loading: false,
      error: action.payload,
      paginatedItems: [],
      totalItemCount: 0,
      totalPageCount: 0,
    })
  )
  .handleAction(
    getActiveAccountDelegationsAsync.success,
    (state, action): State => ({
      ...state,
      loading: false,
      error: null,
      paginatedItems: action.payload.data,
      totalItemCount: action.payload.item_count,
      totalPageCount: action.payload.page_count,
    })
  );
